import React from 'react';
import { observer } from 'mobx-react-lite';
import { Textarea } from 'src/domains/layouts/shared/formComponents/textarea/Textarea';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { PromoCarouselTranslationsState } from './PromoCarouselTranslationsFormState';
import { HomePageCarouselState } from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { LanguagesState } from 'src/AppState/CmsState/LanguagesState/LanguagesState';
import { CmsTranslationsForm } from 'src/domains/layouts/shared/cms/translationsForm/CmsTranslationsForm';

interface PropsType {
    promoTranslationsState: PromoCarouselTranslationsState;
    promoCarouselState: HomePageCarouselState;
    languagesState: LanguagesState;
    isDefaultPromo: boolean;
    formId: number;
}

export const PromoCarouselTranslationsForm = observer(
    ({ promoTranslationsState, languagesState, promoCarouselState, isDefaultPromo, formId }: PropsType) => {
        const { title, subtitle, btnTitle, tcText, language, isNewForm } = promoTranslationsState;

        const formIdsLength = promoCarouselState.formsIds.length;
        const lastFormId = promoCarouselState.formsIds[formIdsLength - 1];
        const isLastForm = lastFormId === formId;
        const isButtonDisabled =
            lastFormId === undefined
                ? false
                : promoCarouselState.getTranslationFormStateById(lastFormId).language.value === '';
        const isAllLanguagesSelected =
            promoCarouselState.formsIds.length === languagesState.getNonDefaultLanguagesList().length;

        return (
            <CmsTranslationsForm
                formLanguage={language}
                handleDelete={(): Promise<void> => promoCarouselState.handleDeleteTranslation(language.value)}
                isModifyMode={promoCarouselState.isEditMode || promoCarouselState.isDuplicateMode}
                isNewForm={isNewForm}
                onClick={promoCarouselState.addLanguageForm}
                showButton={isLastForm && isAllLanguagesSelected === false}
                isDisabled={isButtonDisabled}
                languagesState={languagesState}
                allSelectedLanguages={promoCarouselState.allSelectedLanguages}
                setSelectedLanguages={promoCarouselState.setSelectedLanguages}
                handleShowDeletePopup={promoCarouselState.handleShowDeletePopup}
                handleHideDeletePopup={promoCarouselState.handleHideDeletePopup}
                showDeletePopup={promoCarouselState.showDeletePopup}
            >
                <Textarea
                    formState={title}
                    isEmpty={title.value === ''}
                    label='Title'
                />
                <Textarea
                    formState={subtitle}
                    isEmpty={subtitle.value === ''}
                    label='Subtitle'
                />
                {isDefaultPromo ? (
                    <Input
                        formInputState={btnTitle}
                        isEmpty={btnTitle.value === ''}
                        label='Button call to action text'
                    />
                ) : null}
                <Textarea
                    formState={tcText}
                    isEmpty={tcText.value === ''}
                    label='Terms'
                    ckeditor
                />
            </CmsTranslationsForm>
        );
    }
);
